(() => {
  document.querySelectorAll('[data-install-video]').forEach(card => {
    if (card.dataset.initialized) return;
    card.dataset.initialized = 'true';
    const button = card.querySelector('button'), status = card.querySelector('[data-video-status]');
    button.addEventListener('click', async () => {
      button.disabled = true;
      status.textContent = 'Loading installation video…';
      try {
        const response = await fetch(card.dataset.catalog);
        if (!response.ok) throw new Error('catalog');
        const item = (await response.json())[card.dataset.installVideo];
        const url = new URL(item.url);
        if (url.protocol !== 'https:') throw new Error('source');
        const video = document.createElement('video');
        video.controls = true;
        video.playsInline = true;
        video.preload = 'none';
        video.poster = button.querySelector('img').src;
        video.setAttribute('aria-label', item.title + ' hardware installation');
        video.src = url.href;
        video.addEventListener('error', () => {status.textContent = 'Video could not load. Check your connection and retry, or follow the illustrated instructions below.';button.hidden=false;button.disabled=false;video.remove();});
        button.hidden = true;
        card.insertBefore(video, status);
        video.focus();
        status.textContent = '';
        try {await video.play();} catch {status.textContent = 'Press play to start the installation video.';}
      } catch {
        status.textContent = 'Video could not load. Check your connection and click the cover to retry. You can still follow the illustrated instructions below.';
        button.disabled = false;
      }
    });
  });
})();
